import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_COUPON_QUERY_KEY } from './useGetCoupon';
import { GET_COUPONS_QUERY_KEY } from './useListCoupons';

export function useRevokeCoupon(couponId: string, organizationId: string) {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (userId: string) => {
            return apiClient.fetchApi<{}, { success: boolean }>({
                method: 'DELETE',
                endpoint: `coupons/admin/${couponId}/assign/${userId}`,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: GET_COUPON_QUERY_KEY(couponId),
            });
            queryClient.invalidateQueries({
                queryKey: GET_COUPONS_QUERY_KEY(organizationId),
            });
        },
    });
}
